import { createContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  signOut,
  signInWithPopup,
} from "firebase/auth";

import { auth } from '../firebase';

export const AuthContext = createContext(null);
const googleProvider = new GoogleAuthProvider();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [running, setRunning] = useState(true);

  useEffect(() => {
    const unSubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setRunning(false);
    });
    return () => {
      unSubscribe();
    };
  }, [user]);

  const createNewUser = (email, password) => {
    setRunning(true);
    return createUserWithEmailAndPassword(auth, email, password);
  };

  const UserLogin = (email, password) => {
    setRunning(true);
    return signInWithEmailAndPassword(auth, email, password);
  };

  const userSignOut = () => {
    setRunning(true);
    return signOut(auth);
  };

  const loginWithGoogle = () => {
    setRunning(true);
    return signInWithPopup(auth, googleProvider);
  };

  const contextData = {
    user,
    running,
    createNewUser,
    UserLogin,
    userSignOut,
    loginWithGoogle,
  };

  return (
    <AuthContext.Provider value={contextData}>{children}</AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node,
};

export default AuthProvider;
